import React, { FunctionComponent, FC, ReactNode, CSSProperties } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ variables, palette }: Theme) => ({
  cardWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'column',
    borderRadius: variables?.spacingC,
    border: `1px solid ${palette.jet?.borderDefault}`,
    backgroundColor: palette.jet?.containerDefault,
    paddingBottom: variables?.spacingC,
    transition: 'border 500ms ease-out',
    '&:hover': {
      border: `1px solid ${palette.jet?.supportInfoInverse}`,
    },
    '&.inherit-hover': {
      '&:hover': {
        border: `1px solid ${palette.jet?.borderDefault}`,
      }
    },
    '&.active': {
      border: `1px solid ${palette.jet?.supportInfoInverse}`,
    },
    '& .cardBody': {
      padding: variables?.spacingC,
      paddingBottom: '0',
    },
    '&.clear-padding': {
      padding: 'inherit',
      '& .cardBody': {
        padding: '16px'
      }
      
    }
  },
  cardHeader: {},

  cardFooter: {
    display: 'flex',
    borderTop: `0.5px solid ${palette.jet?.borderDefault}`,
    alignItems: 'center',
    padding: variables?.spacingB,
    paddingBottom: '0',
  },
  cardMenu: {
    //borderTop: `0.5px solid ${palette.jet?.borderDefault}`,
    alignItems: 'center',
    marginTop: `${variables?.spacingB}`,
    overflow:'hidden',
    width:'100%'
  },
}));

interface ITCard {
  children: ReactNode;
  isCardActive?: boolean;
  styles?: CSSProperties;
  removeSpaces?:boolean;
  disableHovering?:boolean;
  onClick: () => void

}

type TCard = FunctionComponent<ITCard> & {
  Header: FC;
  Body: FC;
  Footer: FC;
  Menu: FC;
};

const Card: TCard = ({ children, isCardActive,styles,removeSpaces = false, disableHovering = false ,onClick}): JSX.Element => {
  return (
    <div
      className={`${useStyles().cardWrapper} ${removeSpaces ? 'clear-padding' : ''} ${isCardActive ? 'active' : ''}  ${disableHovering ? 'inherit-hover' : ''}`}
      style={{...styles}}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
const Header: FC = ({ children }): JSX.Element => {
  return <div className={useStyles().cardHeader}>{children}</div>;
};
const Body: FC = ({ children }): JSX.Element => {
  return <div className={'cardBody'}>{children}</div>;
};
const Footer: FC = ({ children }): JSX.Element => {
  return <div className={useStyles().cardFooter}>{children}</div>;
};
const Menu: FC = ({ children }): JSX.Element => {
  return <div className={useStyles().cardMenu}>{children}</div>;
};

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;
Card.Menu = Menu;

export default Card;
